import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'

import './lib/mobiscroll5_14/mobiscroll.react.scss'
import './lib/mobiscroll/mobiscroll.react.scss'
import './languages/i18n'

import Discovery from './services/discovery'

// Chromium reports this when a ResizeObserver callback and layout overlap in one frame; it is benign.
window.addEventListener(
  'error',
  (event: Event) => {
    const message = (event as ErrorEvent).message ?? ''
    if (message.includes('ResizeObserver loop')) {
      event.stopImmediatePropagation()
    }
  },
  true
)

Discovery.then(() => {
  ReactDOM.render(<App />, document.getElementById('root'))
  registerServiceWorker()
}).catch((err) => {
  window.alert(err)
  console.error(err)
})
